import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/Property-Management-Poster-min.png";

const Propertymanagement = () => {
  return (
    <>
     <div className="home-container">
      <Sidebar/>
      <div className="home-content">
        <img
              src={image} // Replace with your image URL
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
    </>
  )
}

export default Propertymanagement